import { useMemo } from 'react';

import type { Client } from '@/types';
import {
  filterClients,
  searchClientsByName,
  sortClients,
  type ClientFilterType,
  type ClientSortDirection,
  type ClientSortField,
} from '../model';

export const useFilteredClients = (
  clients: Client[] | undefined,
  query: string,
  sortBy: ClientSortField,
  sortDirection: ClientSortDirection,
  filterBy: ClientFilterType
): Client[] =>
  useMemo(() => {
    if (!clients) return [];
    const searched = searchClientsByName(clients, query);
    const filtered = filterClients(searched, filterBy);
    return sortClients(filtered, sortBy, sortDirection);
  }, [clients, query, sortBy, sortDirection, filterBy]);
